import React from 'react';
import { useLanguage } from '../lib/LanguageContext';
export function BusinessImpact() {
  const {
    t
  } = useLanguage();
  return <section id="impact" className="py-16 md:py-24 lg:py-40 bg-white border-y border-forest-100" data-id="element-4">
      <div className="container mx-auto px-4 sm:px-6 md:px-8" data-id="element-5">
        <div className="grid md:grid-cols-2 gap-10 lg:gap-20 items-start" data-id="element-6">
          {/* Left: Content */}
          <div className="md:sticky md:top-32" data-id="element-7">
            <p className="text-forest-500 font-semibold text-xs uppercase tracking-[0.2em] mb-6" data-id="element-8">
              {t.impact.label}
            </p>
            <div className="border-l-4 border-brand-gold pl-6 mb-8" data-id="element-9">
              <h2 className="text-4xl md:text-5xl font-bold text-forest-900 tracking-tight leading-tight" data-id="element-10">
                {t.impact.headline}
              </h2>
            </div>
            <p className="text-xl text-forest-700/60 font-light leading-relaxed mb-12" data-id="element-11">
              {t.impact.subtitle}
            </p>
          </div>

          {/* Right: Stats Grid */}
          <div className="grid sm:grid-cols-2 gap-5" data-id="element-12">
            {t.impact.items.map((impact, idx) => <div key={idx} className="bg-forest-50 rounded-2xl p-6 border border-forest-100 hover:border-forest-200 hover:shadow-md transition-all" data-id="element-13">
                <div className="text-4xl font-black text-brand-green mb-3 tracking-tight tabular-nums font-heading" data-id="element-14">
                  {impact.value}
                </div>
                <h4 className="text-sm font-semibold text-forest-800 mb-1" data-id="element-15">
                  {impact.title}
                </h4>
                <p className="text-xs text-forest-600/70 leading-relaxed" data-id="element-16">
                  {impact.desc}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}